import MarkerManager from "./markerManager.js";
import { MAP_DEFAULT_CONFIG } from "./consts.js";
import PropertyService from "./propertyService.js";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

export class GoogleMap {
    constructor(params) {
        this.config = {
            ...this.defaults(),
            ...params,
        };
        if (!this.config.api_key || !this.config.map_id) return;

        this.mapElement = document.querySelector(".js-search-map");
        this.propertyContainer = document.querySelector(
            ".js-search-map__property-container"
        );
        this.selectElement = document.querySelector(".js-search-map__select");
        if (!this.mapElement || !this.propertyContainer) return;
        this.markerManager = null;
        this.map = null;
        this.init();
    }

    defaults() {
        return {
            api_key: null,
            map_id: null,
        };
    }

    init() {
        this.loadMap();
    }

    async loadMap() {
        setOptions({
            key: this.config.api_key,
            version: "weekly",
        });

        const { Map } = await importLibrary("maps");
        await importLibrary("marker");

        this.initializeMap(Map);
        this.markerManager = new MarkerManager(
            this.map,
            this.propertyContainer,
            true,
        );
        await this.markerManager.initializeClusterers();
        this.setupMapEventListeners();
        this.setDefaultSelectValue();
    }

    initializeMap(Map) {
        this.map = new Map(this.mapElement, {
            ...MAP_DEFAULT_CONFIG,
            mapId: this.config.map_id,
        });
    }

    //デフォルトのセレクトボックスの値を取得
    setDefaultSelectValue() {
        const hash = window.location.hash.slice(1);
        if (hash) {
            this.selectElement.value = hash;
        }
    }

    // マップの表示範囲が変更されたときのイベントリスナー
    setupMapEventListeners() {
        this.map.addListener("idle", async () => {
            const bounds = this.map.getBounds();
            if (!bounds) return;
            const northEast = bounds.getNorthEast();
            const southWest = bounds.getSouthWest();
            const type = window.location.hash.slice(1) || "all";
            document
                .querySelector(".js-search-map__loading")
                .removeAttribute("data-hidden");
            // URLからgetパラメータを取得
            const getParams = Object.fromEntries(new URLSearchParams(window.location.search));
            const data = await PropertyService.fetchPropertiesInBounds(
                type,
                southWest.lat(),
                northEast.lat(),
                southWest.lng(),
                northEast.lng(),
                getParams
            );

            await this.markerManager.updateMarkers(data);
            document
                .querySelector(".js-search-map__loading")
                .setAttribute("data-hidden", "");
        });
    }
}
